import { lazy } from 'react';
import Loadable from 'components/common/Loadable/Loadable';
import { mailResourceRequestPath } from './paths';
import LoginPage from 'pages/LoginPage';
import CommonLayout from 'layout/CommonLayout';

const GuestGuard = Loadable(lazy(() => import('lib/route-guard/GuestGuard')));
const ResourceRequestMailPath = Loadable(lazy(() => import('pages/EmailRequest/ResourceRequest')));

const LoginRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: (
                <GuestGuard>
                    <CommonLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: '/',
                    element: <LoginPage />,
                },
                {
                    path: 'login',
                    element: <LoginPage />,
                },
                {
                    path: mailResourceRequestPath(),
                    element: <ResourceRequestMailPath />,
                },
            ],
        },
    ],
};

export default LoginRoutes;
